{
  "leads.nav": "العملاء المحتملون",
  "leads.subtitle": "الاستفسارات القادمة من الموقع وما تضيفه بنفسك. رُدّ عليها بسرعة، وقيّمها، وحوّل الجيد منها إلى مشروعات.",
  "leads.side.label": "نظرة سريعة على الصندوق",
  "leads.loadError": "تعذّر تحميل العملاء المحتملين.",
  "leads.overviewError": "تعذّر تحميل أرقام الصندوق.",
  "leads.loadMore": "عرض المزيد",
  "leads.loadingMore": "جارٍ التحميل…",
  "leads.search": "ابحث في العملاء المحتملين",
  "leads.filter.service": "الخدمة",
  "leads.filter.anyService": "كل الخدمات",
  "leads.tabs.label": "العملاء المحتملون حسب المرحلة",
  "leads.view.label": "طريقة العرض",
  "leads.view.board": "لوحة",
  "leads.view.list": "قائمة",
  "leads.board.column": "{column}، {count, plural, zero {لا عملاء محتملين} one {عميل محتمل واحد} two {عميلان محتملان} few {# عملاء محتملين} many {# عميلًا محتملًا} other {# عميل محتمل}}",
  "leads.board.empty": "لا أحد هنا. اسحب عميلًا إلى هذه المرحلة.",
  "leads.board.picked": "تم التقاط {name}.",
  "leads.board.over": "{name} فوق «{column}».",
  "leads.board.dropped": "تم وضع {name} في «{column}».",
  "leads.board.cancelled": "أُلغي نقل {name}.",
  "leads.state.new": "جديد",
  "leads.state.contacted": "تم التواصل",
  "leads.state.cold": "بارد",
  "leads.state.warm": "دافئ",
  "leads.state.qualified": "مؤهَّل",
  "leads.state.meeting_done": "تم الاجتماع",
  "leads.state.converted": "تحوّل لمشروع",
  "leads.state.lost": "خسرناه",
  "leads.state.all": "الكل",
  "leads.source.consultation": "طلب استشارة",
  "leads.source.message": "رسالة تواصل",
  "leads.source.manual": "أضافه الفريق",
  "leads.new.open": "عميل محتمل جديد",
  "leads.new.title": "عميل محتمل جديد",
  "leads.new.description": "لعميل محتمل وصلنا بالتليفون أو واتساب أو ترشيح. يبدأ في «جديد» ويكون مسؤوليتك حتى تسنده لغيرك.",
  "leads.new.name": "الاسم",
  "leads.new.company": "الشركة (اختياري)",
  "leads.new.phone": "رقم الهاتف",
  "leads.new.phoneHint": "الرقم المحلي يُقرأ كرقم مصري؛ أضف كود الدولة لغيره.",
  "leads.new.email": "البريد الإلكتروني",
  "leads.new.service": "الخدمة",
  "leads.new.serviceUnknown": "غير محددة بعد",
  "leads.new.budget": "الميزانية (اختياري)",
  "leads.new.budgetPlaceholder": "مثلًا ٥٠٬٠٠٠ جنيه",
  "leads.new.message": "المطلوب",
  "leads.new.messagePlaceholder": "ما طلبه العميل، وأي شيء مهم من المكالمة.",
  "leads.new.submit": "إضافة",
  "leads.new.saving": "جارٍ الإضافة…",
  "leads.new.added": "أُضيف {name} إلى «جديد»",
  "leads.new.errors.name": "اكتب اسم العميل المحتمل.",
  "leads.new.errors.email": "اكتب بريدًا إلكترونيًا صحيحًا.",
  "leads.new.errors.phone": "اكتب رقمًا صحيحًا، مع كود الدولة لغير الأرقام المصرية.",
  "leads.new.errors.reach": "أضف رقم هاتف أو بريدًا إلكترونيًا حتى يستطيع الفريق الرد.",
  "leads.new.errors.tooLong": "النص طويل جدًا.",
  "leads.kpi.newThisWeek": "جديد هذا الأسبوع",
  "leads.kpi.total": "{count, plural, zero {لا عملاء محتملين} one {عميل محتمل واحد إجمالًا} two {عميلان محتملان إجمالًا} few {# عملاء محتملين إجمالًا} many {# عميلًا محتملًا إجمالًا} other {# عميل محتمل إجمالًا}}",
  "leads.kpi.uncontacted": "ينتظر أكثر من ٢٤ ساعة",
  "leads.kpi.uncontactedCaption": "جديد ولم نردّ عليه بعد",
  "leads.kpi.allAnswered": "تم الرد على الجميع",
  "leads.kpi.conversion": "معدّل التحويل",
  "leads.kpi.conversionCaption": "كسبنا {count} من {total, plural, zero {لا شيء} one {عميل محتمل محسوم} two {عميلين محتملين محسومين} few {# عملاء محتملين محسومين} many {# عميلًا محتملًا محسومًا} other {# عميل محتمل محسوم}}",
  "leads.kpi.conversionEmpty": "لم نكسب أو نخسر أي عميل محتمل بعد",
  "leads.kpi.response": "متوسط أول رد",
  "leads.kpi.responseEmpty": "لم نردّ على أي عميل محتمل بعد",
  "leads.kpi.goalMet": "ضمن هدف الساعتين",
  "leads.kpi.goalMissed": "أبطأ من هدف الساعتين",
  "leads.duration.minutes": "{minutes} د",
  "leads.duration.hoursMinutes": "{hours} س {minutes} د",
  "leads.duration.daysHours": "{days} ي {hours} س",
  "leads.pipeline.title": "مسار العملاء",
  "leads.pipeline.description": "كل العملاء المحتملين حسب المرحلة",
  "leads.sync.now": "مزامنة الآن",
  "leads.sync.running": "جارٍ المزامنة…",
  "leads.sync.last": "آخر مزامنة {when}",
  "leads.sync.never": "لم تتم المزامنة بعد",
  "leads.sync.notConfigured": "الموقع غير متصل",
  "leads.sync.done": "{count, plural, zero {لا جديد من الموقع} one {عميل محتمل جديد من الموقع} two {عميلان محتملان جديدان من الموقع} few {# عملاء محتملين جدد من الموقع} many {# عميلًا محتملًا جديدًا من الموقع} other {# عميل محتمل جديد من الموقع}}",
  "leads.sync.upToDate": "الصندوق محدَّث.",
  "leads.row.noService": "الخدمة غير محددة",
  "leads.row.owner": "المسؤول: {name}",
  "leads.row.cold": "ينتظر أكثر من ٢٤ ساعة",
  "leads.actions.whatsapp": "واتساب {name}",
  "leads.actions.call": "اتصال بـ {name}",
  "leads.empty.title": "لا يوجد عملاء محتملون بعد",
  "leads.empty.body": "تصل هنا استفسارات نموذجي الاستشارة والتواصل في الموقع. زامن لجلب الأحدث.",
  "leads.empty.new.title": "لا جديد",
  "leads.empty.new.body": "تم استلام كل العملاء المحتملين. الاستفسارات الجديدة تظهر هنا أولًا.",
  "leads.empty.contacted.title": "لا محادثات مفتوحة",
  "leads.empty.contacted.body": "من رددت عليهم ينتظرون هنا حتى تؤهّلهم أو تغلقهم.",
  "leads.empty.cold.title": "لا عملاء باردون",
  "leads.empty.cold.body": "من توقّفوا عن الرد أو ليسوا جاهزين بعد ينتظرون هنا حتى يسخنوا.",
  "leads.empty.warm.title": "لا عملاء دافئون",
  "leads.empty.warm.body": "من يُظهرون اهتمامًا حقيقيًا ينتظرون هنا حتى يتأهّلوا.",
  "leads.empty.qualified.title": "لا عملاء مؤهَّلون",
  "leads.empty.qualified.body": "العملاء المناسبون، بميزانية واحتياج واضح، جاهزون ليصبحوا مشروعات.",
  "leads.empty.meeting_done.title": "لا اجتماعات تمّت",
  "leads.empty.meeting_done.body": "من اجتمعت بهم ينتظرون هنا العرض والقرار.",
  "leads.empty.converted.title": "لا تحويلات بعد",
  "leads.empty.converted.body": "من تحوّلهم إلى مشروعات يبقون هنا مرتبطين بالعميل والمشروع.",
  "leads.empty.lost.title": "لم نخسر أحدًا",
  "leads.empty.lost.body": "يُحفظ سبب كل خسارة، لنعرف ما الذي نخسر أمامه.",
  "leads.empty.all.title": "لا يوجد عملاء محتملون بعد",
  "leads.empty.all.body": "تصل هنا استفسارات نموذجي الاستشارة والتواصل في الموقع.",
  "leads.noResults.title": "لا نتائج مطابقة",
  "leads.noResults.body": "جرّب اسمًا أو رقمًا أو خدمة أخرى.",
  "leads.noResults.clear": "مسح عوامل التصفية",
  "leads.sheet.label": "عميل محتمل",
  "leads.sheet.received": "وصل {when}",
  "leads.sheet.loadError": "تعذّر تحميل هذا العميل المحتمل",
  "leads.sheet.loadErrorBody": "تحقّق من الاتصال وحاول مرة أخرى.",
  "leads.sheet.message": "رسالته",
  "leads.sheet.budget": "الميزانية",
  "leads.sheet.contact": "بيانات التواصل",
  "leads.sheet.convertedTitle": "تحوّل إلى المشروع {key}",
  "leads.sheet.convertedBody": "العميل: {client}",
  "leads.sheet.openProject": "فتح المشروع",
  "leads.field.phone": "الهاتف",
  "leads.field.whatsapp": "واتساب",
  "leads.field.email": "البريد",
  "leads.field.language": "اللغة",
  "leads.field.owner": "المسؤول",
  "leads.field.noOwner": "لا أحد بعد",
  "leads.field.received": "تاريخ الوصول",
  "leads.field.none": "غير متوفر",
  "leads.matches.title": "عملاء حاليون",
  "leads.matches.description": "عملاء لديهم جهة اتصال بنفس الهاتف أو البريد",
  "leads.matches.none": "لا يوجد عميل بهذا الهاتف أو البريد. يبدو أنه عميل جديد.",
  "leads.matches.phone": "الهاتف",
  "leads.matches.email": "البريد",
  "leads.notes.title": "ملاحظات",
  "leads.notes.placeholder": "ماذا قال؟ وما الخطوة التالية؟",
  "leads.notes.saved": "تم حفظ الملاحظات",
  "leads.triage.label": "المرحلة",
  "leads.triage.moved": "انتقل إلى «{status}»",
  "leads.lost.title": "تسجيل العميل المحتمل كخسارة",
  "leads.lost.description": "لماذا لم يكتمل؟ السبب يساعدنا على معرفة ما نخسر أمامه.",
  "leads.lost.reason": "السبب",
  "leads.lost.confirm": "تسجيل كخسارة",
  "leads.lostReason.budget": "الميزانية صغيرة",
  "leads.lostReason.timing": "التوقيت غير مناسب",
  "leads.lostReason.no_response": "توقّف عن الرد",
  "leads.lostReason.competitor": "اختار جهة أخرى",
  "leads.lostReason.not_a_fit": "لا يناسبنا",
  "leads.lostReason.spam": "رسالة مزعجة أو تجربة",
  "leads.lostReason.closed_on_website": "أُغلق على الموقع",
  "leads.lostReason.other": "سبب آخر",
  "leads.remote.pendingTitle": "الموقع لم يعلم بالتغيير بعد",
  "leads.remote.retry": "إعادة المزامنة",
  "leads.remote.synced": "الموقع محدَّث.",
  "leads.convert.open": "تحويل لمشروع",
  "leads.convert.title": "تحويل إلى مشروع",
  "leads.convert.description": "ينشئ العميل وجهة الاتصال والمشروع لـ {name} في خطوة واحدة، ويغلق الطلب على الموقع.",
  "leads.convert.clientSection": "العميل",
  "leads.convert.clientMode": "من العميل؟",
  "leads.convert.newClient": "عميل جديد",
  "leads.convert.newClientHint": "إضافته مع هذا الشخص كجهة الاتصال الرئيسية",
  "leads.convert.existingClient": "عميل حالي",
  "leads.convert.existingHint": "إضافة المشروع إلى عميل لدينا بالفعل",
  "leads.convert.existingMatched": "{count, plural, zero {لا عملاء مطابقين} one {عميل واحد يطابق هذا الطلب} two {عميلان يطابقان هذا الطلب} few {# عملاء يطابقون هذا الطلب} many {# عميلًا يطابقون هذا الطلب} other {# عميل يطابقون هذا الطلب}}",
  "leads.convert.client": "العميل",
  "leads.convert.clientPlaceholder": "اختر عميلًا",
  "leads.convert.matched": "يطابق هذا الطلب",
  "leads.convert.clientName": "اسم العميل",
  "leads.convert.country": "الدولة",
  "leads.convert.language": "اللغة",
  "leads.convert.projectSection": "المشروع",
  "leads.convert.submit": "إنشاء العميل والمشروع",
  "leads.convert.working": "جارٍ التحويل…",
  "leads.convert.done": "تم إنشاء المشروع {key}",
  "leads.convert.errors.clientName": "اكتب اسم العميل (حرفان على الأقل).",
  "leads.convert.errors.client": "اختر العميل.",
  "leads.convert.errors.clientTaken": "يوجد عميل بهذا الاسم. اختره كعميل حالي.",
  "leads.errors.alreadyConverted": "هذا العميل المحتمل تحوّل لمشروع بالفعل.",
  "leads.errors.notFound": "هذا العميل المحتمل لم يعد موجودًا.",
  "leads.errors.notConfigured": "الموقع غير متصل بعد. اطلب من المسؤول ضبط مفتاح المزامنة.",
  "leads.errors.unavailable": "تعذّر الوصول إلى الموقع. حاول بعد دقيقة.",
  "leads.errors.conflict": "عدّل شخص آخر هذا العميل المحتمل. تم تحديثه."
}
